import { environment } from 'src/environments/environment'

/**
 * prnt = print
 *
 */
export function prnt(...input: any) {
  if (!environment.production && isBrowser()) {
    console.log(input)
  }
}

/**
 * prE = print error
 */
export function prntError(...input: any) {
  if (isBrowser()) {
    console.error(input)
  }
}

/**
 * Poor check if we are inside a browser. Better would be platform thing of
 * angular, but I want to avoid the need to inject above methods. I want simple
 * importing to suffice.
 */
function isBrowser() {
  return typeof window !== 'undefined'
}
